


































import {
  Vue,
  Component,
} from "@/shared/vuepack";
import Button from "@/shared/components/ui/Button.vue";
import { Validator } from "vee-validate";
import Input from "@/shared/components/ui/Input.vue";
import ErrorSummary from "@/shared/components/ErrorSummary.vue";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import { useUtilityStore } from "@/admin/store/utility";

@Component({
  components: {
    Button,
    Input,
    ErrorSummary,
    GenericLoadingSpinner
  }
})
export default class AdminEmailChange extends Vue {
  $validator: Validator;

  utilityStore = useUtilityStore();

  mounted () {
    this.utilityStore.loadTestUsers();
  }
}

